module.exports = __webpack_public_path__ + "img/DB4-1920_01.23960e29.jpg";